<template>
  <section class="">
    <div class="wrapper">
      <div
        data-aos="fade-up"
        data-aos-duration="1300"
        data-aos-delay="100"
        class="d-flex justify-content-center img-wrapper"
      >
        <img src="@/assets/mobile-app.svg" />
      </div>
      <div class="text-area">
        <h1
          class=""
          data-aos="fade-left"
          data-aos-duration="1300"
          data-aos-delay="150"
        >
          Remote Access to Your Generator System
        </h1>
        <div class="row grid-row remote-access">
          <div
            class="row inner-grid"
            data-aos="fade-left"
            data-aos-duration="1300"
            data-aos-delay="200"
          >
            <div class="col-lg-6 col-sm-12 mt-4">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 15H21C19.9391 15 18.9217 14.5786 18.1716 13.8284C17.4214 13.0783 17 12.0609 17 11V8C17 6.93913 17.4214 5.92172 18.1716 5.17157C18.9217 4.42143 19.9391 4 21 4H24C25.0609 4 26.0783 4.42143 26.8284 5.17157C27.5786 5.92172 28 6.93913 28 8V11C28 12.0609 27.5786 13.0783 26.8284 13.8284C26.0783 14.5786 25.0609 15 24 15ZM21 6C20.4696 6 19.9609 6.21071 19.5858 6.58579C19.2107 6.96086 19 7.46957 19 8V11C19 11.5304 19.2107 12.0391 19.5858 12.4142C19.9609 12.7893 20.4696 13 21 13H24C24.5304 13 25.0391 12.7893 25.4142 12.4142C25.7893 12.0391 26 11.5304 26 11V8C26 7.46957 25.7893 6.96086 25.4142 6.58579C25.0391 6.21071 24.5304 6 24 6H21Z"
                  fill="white"
                />
                <path
                  d="M11 15H8C6.93913 15 5.92172 14.5786 5.17157 13.8284C4.42143 13.0783 4 12.0609 4 11V8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42143 6.93913 4 8 4H11C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8V11C15 12.0609 14.5786 13.0783 13.8284 13.8284C13.0783 14.5786 12.0609 15 11 15ZM8 6C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8V11C6 11.5304 6.21071 12.0391 6.58579 12.4142C6.96086 12.7893 7.46957 13 8 13H11C11.5304 13 12.0391 12.7893 12.4142 12.4142C12.7893 12.0391 13 11.5304 13 11V8C13 7.46957 12.7893 6.96086 12.4142 6.58579C12.0391 6.21071 11.5304 6 11 6H8Z"
                  fill="white"
                />
                <path
                  d="M11 28H8C6.93913 28 5.92172 27.5786 5.17157 26.8284C4.42143 26.0783 4 25.0609 4 24V21C4 19.9391 4.42143 18.9217 5.17157 18.1716C5.92172 17.4214 6.93913 17 8 17H11C12.0609 17 13.0783 17.4214 13.8284 18.1716C14.5786 18.9217 15 19.9391 15 21V24C15 25.0609 14.5786 26.0783 13.8284 26.8284C13.0783 27.5786 12.0609 28 11 28ZM8 19C7.46957 19 6.96086 19.2107 6.58579 19.5858C6.21071 19.9609 6 20.4696 6 21V24C6 24.5304 6.21071 25.0391 6.58579 25.4142C6.96086 25.7893 7.46957 26 8 26H11C11.5304 26 12.0391 25.7893 12.4142 25.4142C12.7893 25.0391 13 24.5304 13 24V21C13 20.4696 12.7893 19.9609 12.4142 19.5858C12.0391 19.2107 11.5304 19 11 19H8Z"
                  fill="white"
                />
                <path
                  d="M24 28H21C19.9391 28 18.9217 27.5786 18.1716 26.8284C17.4214 26.0783 17 25.0609 17 24V21C17 19.9391 17.4214 18.9217 18.1716 18.1716C18.9217 17.4214 19.9391 17 21 17H24C25.0609 17 26.0783 17.4214 26.8284 18.1716C27.5786 18.9217 28 19.9391 28 21V24C28 25.0609 27.5786 26.0783 26.8284 26.8284C26.0783 27.5786 25.0609 28 24 28ZM21 19C20.4696 19 19.9609 19.2107 19.5858 19.5858C19.2107 19.9609 19 20.4696 19 21V24C19 24.5304 19.2107 25.0391 19.5858 25.4142C19.9609 25.7893 20.4696 26 21 26H24C24.5304 26 25.0391 25.7893 25.4142 25.4142C25.7893 25.0391 26 24.5304 26 24V21C26 20.4696 25.7893 19.9609 25.4142 19.5858C25.0391 19.2107 24.5304 19 24 19H21Z"
                  fill="white"
                />
              </svg>
              <h2>Cost Effective</h2>
              <p>
                Gensys provides your company with a cost-effective fueling
                system operation, saving you money.
              </p>
            </div>

            <div class="col-lg-6 col-sm-12 mt-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2445_4911)">
                  <path
                    d="M19.1899 11.8857C19.1899 11.3828 18.7874 10.9754 18.2913 10.9754H12.792V5.48421V5.48404C12.792 4.97943 12.3825 4.57015 11.8783 4.57015C11.3736 4.57015 10.9642 4.97943 10.9642 5.48404V11.8821C10.9642 12.3869 11.3736 12.7962 11.8783 12.7962H18.2918C18.7874 12.7962 19.1899 12.3886 19.1899 11.8857ZM21.9343 11.8799C21.9343 17.4337 17.4327 21.936 11.8801 21.936C6.32715 21.936 1.82593 17.4337 1.82593 11.8799C1.82593 6.32614 6.32715 1.82389 11.8801 1.82389C17.4327 1.82389 21.9343 6.32614 21.9343 11.8799ZM23.7599 11.8799C23.7599 5.31877 18.4411 0 11.8801 0C5.31877 0 0 5.31877 0 11.8799C0 18.4411 5.31877 23.7599 11.8801 23.7599C18.4411 23.7599 23.7599 18.4411 23.7599 11.8799Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2445_4911">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <h2>Performance Check</h2>
              <p>
                Ensure that your company’s generator is in top condition with
                Gensys regular performance check
              </p>
            </div>
          </div>

          <div
            class="row mt-5 align-middle half"
            data-aos="fade-left"
            data-aos-duration="1300"
            data-aos-delay="250"
          >
            <div class="col-lg-6 col-sm-12 mt-4">
              <svg
                width="30"
                height="29"
                viewBox="0 0 30 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.89258 15.6572V23.3252C5.89258 23.6567 6.02427 23.9747 6.25869 24.2091C6.49312 24.4435 6.81106 24.5752 7.14258 24.5752C7.4741 24.5752 7.79204 24.4435 8.02646 24.2091C8.26088 23.9747 8.39258 23.6567 8.39258 23.3252V15.6572C8.39258 15.3257 8.26088 15.0078 8.02646 14.7733C7.79204 14.5389 7.4741 14.4072 7.14258 14.4072C6.81106 14.4072 6.49312 14.5389 6.25869 14.7733C6.02427 15.0078 5.89258 15.3257 5.89258 15.6572Z"
                  fill="white"
                />
                <path
                  d="M13.75 11.8047V23.3252C13.75 23.6567 13.8817 23.9747 14.1161 24.2091C14.3505 24.4435 14.6685 24.5752 15 24.5752C15.3315 24.5752 15.6495 24.4435 15.8839 24.2091C16.1183 23.9747 16.25 23.6567 16.25 23.3252V11.8047C16.25 11.4732 16.1183 11.1552 15.8839 10.9208C15.6495 10.6864 15.3315 10.5547 15 10.5547C14.6685 10.5547 14.3505 10.6864 14.1161 10.9208C13.8817 11.1552 13.75 11.4732 13.75 11.8047Z"
                  fill="white"
                />
                <path
                  d="M22.8574 8.62891C22.6933 8.62889 22.5307 8.66122 22.3791 8.72403C22.2274 8.78685 22.0896 8.87892 21.9735 8.995C21.8574 9.11107 21.7654 9.24888 21.7025 9.40054C21.6397 9.5522 21.6074 9.71475 21.6074 9.87891V23.3252C21.6074 23.6567 21.7391 23.9747 21.9735 24.2091C22.208 24.4435 22.5259 24.5752 22.8574 24.5752C23.1889 24.5752 23.5069 24.4435 23.7413 24.2091C23.9757 23.9747 24.1074 23.6567 24.1074 23.3252V9.87891C24.1074 9.71475 24.0751 9.5522 24.0123 9.40054C23.9495 9.24888 23.8574 9.11107 23.7413 8.995C23.6253 8.87892 23.4875 8.78685 23.3358 8.72403C23.1841 8.66122 23.0216 8.62889 22.8574 8.62891Z"
                  fill="white"
                />
                <path
                  d="M28.75 26H1.25C0.918479 26 0.600537 26.1317 0.366117 26.3661C0.131696 26.6005 0 26.9185 0 27.25C0 27.5815 0.131696 27.8995 0.366117 28.1339C0.600537 28.3683 0.918479 28.5 1.25 28.5H28.75C29.0815 28.5 29.3995 28.3683 29.6339 28.1339C29.8683 27.8995 30 27.5815 30 27.25C30 26.9185 29.8683 26.6005 29.6339 26.3661C29.3995 26.1317 29.0815 26 28.75 26Z"
                  fill="white"
                />
                <path
                  d="M4.6641 10.0454C4.81517 10.1098 4.97748 10.1438 5.14171 10.1454C5.30595 10.1471 5.46889 10.1163 5.6212 10.0548C5.77351 9.99333 5.91219 9.90243 6.02932 9.78729C6.14644 9.67215 6.2397 9.53503 6.30375 9.38379C6.90808 8.03449 8.00032 6.96365 9.36131 6.38612C10.7223 5.80859 12.2513 5.76711 13.6416 6.27C14.5426 6.59822 15.4943 6.76564 16.4532 6.76463C17.6018 6.76075 18.7378 6.524 19.7924 6.0687C20.847 5.61339 21.7983 4.94899 22.5889 4.11563V6.15576C22.5889 6.48728 22.7206 6.80522 22.955 7.03964C23.1894 7.27406 23.5074 7.40576 23.8389 7.40576C24.1704 7.40576 24.4884 7.27406 24.7228 7.03964C24.9572 6.80522 25.0889 6.48728 25.0889 6.15576V1.25C25.0889 1.08584 25.0566 0.923294 24.9938 0.771632C24.931 0.619969 24.8389 0.482166 24.7228 0.36609C24.6067 0.250015 24.4689 0.157941 24.3173 0.0951265C24.1656 0.0323123 24.0031 -1.18172e-05 23.8389 3.24077e-09H18.9287C18.5972 3.24077e-09 18.2793 0.131696 18.0449 0.366117C17.8104 0.600537 17.6787 0.918479 17.6787 1.25C17.6787 1.58152 17.8104 1.89946 18.0449 2.13388C18.2793 2.3683 18.5972 2.5 18.9287 2.5H20.7004C19.9096 3.30317 18.9058 3.86366 17.8071 4.11548C16.7085 4.3673 15.5607 4.29996 14.499 3.92139C12.5065 3.20624 10.3172 3.27109 8.3704 4.10292C6.42365 4.93474 4.86349 6.47201 4.00297 8.40625C3.93875 8.55729 3.90491 8.7195 3.90337 8.88362C3.90184 9.04773 3.93265 9.21055 3.99405 9.36276C4.05544 9.51497 4.14621 9.6536 4.26118 9.77073C4.37614 9.88786 4.51306 9.98119 4.6641 10.0454Z"
                  fill="white"
                />
              </svg>

              <h2>Strengthen Operations</h2>
              <p>
                Gensys helps you to streamline and optimize your company’s
                fueling operations, making them more effective and productive.
              </p>
            </div>

            <div class="col-lg-6 col-sm-12 mt-4">
              <svg
                width="30"
                height="25"
                viewBox="0 0 30 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.71168 22.3297C4.6472 22.3298 4.58339 22.3166 4.52424 22.2909C4.4651 22.2652 4.41188 22.2276 4.36793 22.1805C2.13744 19.786 0.899067 16.6341 0.903086 13.3617C0.903086 6.21641 6.71871 0.40625 13.8617 0.40625C13.986 0.40625 14.1052 0.455636 14.1931 0.543544C14.281 0.631452 14.3304 0.75068 14.3304 0.875V14.0586C14.3305 14.1265 14.3157 14.1936 14.2873 14.2552C14.2588 14.3169 14.2173 14.3716 14.1656 14.4156L5.01559 22.218C4.93077 22.2901 4.82304 22.3297 4.71168 22.3297ZM13.3929 1.35C6.98121 1.59688 1.84059 6.89063 1.84059 13.3617C1.83694 16.2425 2.8718 19.0281 4.75543 21.2078L13.3929 13.8438V1.35Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
                <path
                  d="M16.1381 27.5934C14.3565 27.5903 12.5944 27.2212 10.9613 26.509C9.32815 25.7967 7.8588 24.7564 6.64439 23.4527C6.60138 23.4064 6.56819 23.3518 6.54683 23.2922C6.52547 23.2327 6.51638 23.1695 6.5201 23.1063C6.52382 23.0432 6.54028 22.9815 6.56849 22.9249C6.5967 22.8683 6.63607 22.8179 6.68424 22.777L15.6686 15.1152V2.14648C15.6686 2.02216 15.718 1.90294 15.8059 1.81503C15.8938 1.72712 16.013 1.67773 16.1374 1.67773C23.2827 1.67773 29.096 7.49102 29.096 14.6363C29.096 21.7816 23.2811 27.5934 16.1381 27.5934ZM7.67174 23.1699C9.92606 25.3994 12.9676 26.6517 16.1381 26.6559C22.7663 26.6559 28.1592 21.2652 28.1592 14.6348C28.1592 8.16367 23.0186 2.86992 16.6069 2.62305V15.3348C16.6069 15.4027 16.5922 15.4698 16.5637 15.5314C16.5353 15.593 16.4937 15.6478 16.4421 15.6918L7.67174 23.1699Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
                <path
                  d="M23.9914 24.8188C23.9245 24.8187 23.8583 24.8043 23.7974 24.7766C23.7365 24.7488 23.6822 24.7083 23.6383 24.6578L15.7851 15.6406C15.7246 15.573 15.685 15.4891 15.6712 15.3994C15.6574 15.3096 15.67 15.2178 15.7074 15.1351C15.7448 15.0523 15.8054 14.9822 15.8819 14.9333C15.9584 14.8843 16.0475 14.8587 16.1383 14.8594H28.6281C28.7524 14.8594 28.8717 14.9088 28.9596 14.9967C29.0475 15.0846 29.0969 15.2038 29.0969 15.3281C29.0969 15.4525 29.0475 15.5717 28.9596 15.6596C28.8717 15.7475 28.7524 15.7969 28.6281 15.7969H17.1687L24.3453 24.0352C24.4044 24.103 24.4427 24.1865 24.4557 24.2755C24.4686 24.3646 24.4556 24.4555 24.4183 24.5374C24.381 24.6193 24.3209 24.6887 24.2452 24.7373C24.1695 24.786 24.0814 24.8118 23.9914 24.8117V24.8188Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5"
                />
              </svg>

              <h2>Accurate report</h2>
              <p>
                Get accurate and detailed reports on your generator's
                performance, identify potential problems and take corrective
                action to prevent them.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BlackBanner",
};
</script>

<style scoped>
section {
  background: linear-gradient(110.28deg, #000000 22.34%, #020202 50.01%);
  overflow: hidden;
}
.wrapper {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.text-area {
  margin-top: 4%;
}
h2 {
  color: white;
  font-size: 24px;
  margin-top: 10px;
}

p {
  color: #d1d3d4;
  width: 80%;
  margin-top: 30px;
}

h1 {
  color: white;
  font-size: 32px;
  padding-left: 80px;
  margin-bottom: 40px;
}
img {
  margin-left: -40px;
}

@media screen and (max-width: 800px) {
  .remote-access {
    text-align: left !important;
  }
  .wrapper {
    flex-direction: column-reverse;
  }
  img {
    width: 300px;
    margin-left: 27px;
  }
  .img-wrapper {
    width: 100%;
    margin: auto;
  }
  .half {
    margin-top: 10px !important ;

    padding-right: 0 !important;
    width: 90%;
    margin: auto;
  }
  section {
    flex-direction: column-reverse;
    text-align: center;
  }
  h1 {
    font-size: 24px;
    padding-left: 0px;

    width: 90%;
    margin: 20px auto;
  }
  h2 {
    font-size: 18px;
    margin-top: 10px;
  }
  p {
    width: 100%;
    font-size: 13px;
    margin-top: 10px;
  }
  .inner-grid {
    padding-right: 0 !important;
    width: 90%;
    margin: auto;
  }
  .text-area {
    width: 100%;
    text-align: center;
    margin-top: 15px;
  }
}
</style>
